import { CommandType } from "../../../../common/services/cqs/CommandType";
import { AtgardSkogsvardTradslag } from "../../models/skogsvard/skogsvard-models";
import { SkogsvardTradslagBaseCommand } from "./SkogsvardTradslagBaseCommand";

export class UpdateSkogsvardTradslagCommand extends SkogsvardTradslagBaseCommand {
    readonly tradslagId: number;
    readonly antalPlantor: number;
    readonly frogiva: number;
    readonly arealandel: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateSkogsvardTradslagCommand";

    constructor(atgardGuid: string, tradslag: AtgardSkogsvardTradslag) {
        super(atgardGuid, tradslag.guid, UpdateSkogsvardTradslagCommand.$type, CommandType.Replace);
        this.tradslagId = tradslag.tradslagId;
        this.antalPlantor = tradslag.antalPlantor;
        this.frogiva = tradslag.frogiva;
        this.arealandel = tradslag.arealandel;
    }
}
